import { RelatoriosBIVendas } from "../RelatoriosBIVendas";

export default function RelatorioBIVendasLead() {
    return (
        <RelatoriosBIVendas
            dsModuloBI="BIVendas"
            dsDashBoardBI="BIDashboardLeads"
        />
    );
}
